export enum MatchStateEnum {
  Scheduled = 0,
  InProgress = 1,
  Completed = 2,
}
